import React from "react";
import { Navbar, BrookvilleMap, GLOBAL_STYLES } from "../components.jsx";
import { BLUE, NAVY, LIGHT, TEXT, MUTED, GREEN, isWinter } from "../data";

export default function About() {
  return (
    <div style={{fontFamily:"'Outfit',sans-serif",background:"#fff",color:TEXT,minHeight:"100vh"}}>
      <style>{GLOBAL_STYLES}</style>
      <Navbar activePage="about"/>

      {/* HEADER */}
      <section style={{padding:"110px 48px 60px",background:NAVY}}>
        <div style={{maxWidth:760,margin:"0 auto"}}>
          <p style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,0.45)",letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:10}}>About Kodiak</p>
          <h1 style={{fontSize:"clamp(30px,5vw,52px)",fontWeight:800,color:"#fff",marginBottom:14,letterSpacing:"-0.02em",lineHeight:1.1}}>
            About <span style={{color:"rgba(255,255,255,0.4)"}}>Kodiak</span>
          </h1>
          <p style={{fontSize:15,color:"rgba(255,255,255,0.55)",lineHeight:1.75,maxWidth:480,marginBottom:28}}>
            Professional auto detailing serving Brookville, Ohio and the surrounding Dayton area. Mobile and drop-off available.
          </p>
          <div style={{display:"flex",gap:12,flexWrap:"wrap"}}>
            <a href="/#book" style={{background:"#fff",color:NAVY,padding:"12px 26px",borderRadius:6,fontWeight:700,fontSize:14,textDecoration:"none",display:"inline-block"}}>Start Booking</a>
            <a href="/" style={{background:"transparent",color:"rgba(255,255,255,0.65)",border:"1.5px solid rgba(255,255,255,0.25)",padding:"12px 26px",borderRadius:6,fontWeight:600,fontSize:14,textDecoration:"none",display:"inline-block"}}>Back to Home</a>
          </div>
        </div>
      </section>

      {/* ABOUT BRAD */}
      <section style={{padding:"72px 48px",background:"#fff"}}>
        <div style={{maxWidth:860,margin:"0 auto"}}>
          <p style={{fontSize:12,fontWeight:600,color:BLUE,letterSpacing:"0.08em",textTransform:"uppercase",marginBottom:10}}>Who You're Working With</p>
          <h2 style={{fontSize:"clamp(22px,3vw,36px)",fontWeight:800,color:NAVY,marginBottom:20,letterSpacing:"-0.02em"}}>Hi, I'm Brad.</h2>
          <div style={{maxWidth:580}}>
            <div>
              <p style={{fontSize:15,color:MUTED,lineHeight:1.85,marginBottom:14}}>Owner and sole detailer at Kodiak Detailing. Every car gets full, undivided attention from start to finish. No crew, no hand-offs.</p>
              <p style={{fontSize:15,color:MUTED,lineHeight:1.85,marginBottom:14}}>Attention to detail is not optional here. Every surface gets addressed, every corner gets cleaned, and the job is not done until it actually is. Safe, consistent, and complete every single time.</p>
              <p style={{fontSize:15,color:MUTED,lineHeight:1.85}}>Started in the Springfield area, now proudly based in Brookville, Ohio.</p>
              <div style={{display:"flex",flexDirection:"column",gap:12,marginTop:24}}>
                {[
                  ["Every surface, every corner, every time. Nothing gets skipped."],
                  ["The job is done when it is actually done. No half-finished sections."],
                  ["The same careful process on every single visit."],
                  ["No crew, no hand-offs. You always know exactly who touched your car."],
                ].map(([d],i)=>(
                  <div key={i} style={{display:"flex",gap:11,alignItems:"flex-start"}}>
                    <div style={{width:22,height:22,borderRadius:"50%",background:BLUE,color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,flexShrink:0,marginTop:1}}>✓</div>
                    <p style={{fontSize:13,color:MUTED,lineHeight:1.65}}>{d}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* LOCATION */}
      <section style={{padding:"64px 48px",background:"#F9FAFB",borderTop:"1px solid #E5E7EB"}}>
        <div style={{maxWidth:900,margin:"0 auto"}}>
          <p style={{fontSize:12,fontWeight:600,color:BLUE,letterSpacing:"0.08em",textTransform:"uppercase",marginBottom:10}}>Service Area</p>
          <h2 style={{fontSize:"clamp(20px,3vw,34px)",fontWeight:800,color:NAVY,marginBottom:8,letterSpacing:"-0.02em"}}>Mobile or Drop-Off, Your Choice</h2>
          <p style={{fontSize:14,color:MUTED,marginBottom:24}}>Both options available. Pick what works for your schedule.</p>

          {/* Both cards with matching border style */}
          <div className="two-col" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:28}}>
            <div style={{background:"#fff",border:"1.5px solid #E5E7EB",borderRadius:12,padding:"20px"}}>
              <div style={{fontSize:24,marginBottom:10}}>📱</div>
              <h3 style={{fontSize:16,fontWeight:800,color:NAVY,marginBottom:6}}>Mobile Detailing</h3>
              <p style={{fontSize:13,color:MUTED,lineHeight:1.7,marginBottom:10}}>Service comes directly to your location. Needs a water hookup and an outlet nearby. All equipment brought on-site.</p>
              {!isWinter
                ?<p style={{fontSize:12,fontWeight:600,color:GREEN}}>✓ Available now through late October</p>
                :<p style={{fontSize:12,fontWeight:600,color:MUTED}}>Resumes in spring</p>
              }
            </div>
            <div style={{background:"#fff",border:"1.5px solid #E5E7EB",borderRadius:12,padding:"20px"}}>
              <div style={{fontSize:24,marginBottom:10}}>🏠</div>
              <h3 style={{fontSize:16,fontWeight:800,color:NAVY,marginBottom:6}}>Drop-Off in Brookville</h3>
              <p style={{fontSize:13,color:MUTED,lineHeight:1.7,marginBottom:10}}>Drop your car off at our Brookville, Ohio location. Everything handled on-site. Pick back up when done.</p>
              <p style={{fontSize:12,fontWeight:600,color:GREEN}}>✓ Available year-round</p>
            </div>
          </div>

          <div style={{marginBottom:28}}><BrookvilleMap/></div>

          {/* Header before distance cards */}
          <div style={{marginBottom:16}}>
            <p style={{fontSize:12,fontWeight:600,color:BLUE,letterSpacing:"0.08em",textTransform:"uppercase",marginBottom:4}}>About Mobile Service</p>
            <p style={{fontSize:14,color:MUTED}}>Distance from Brookville determines mobile availability and whether any travel rate applies.</p>
          </div>

          <div className="three-col" style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12}}>
            {[
              {color:"#22C55E",q:"Within 30 minutes of Brookville",a:"Mobile service included at no extra charge."},
              {color:BLUE,q:"30 to 60+ minutes out",a:"A small travel rate may apply, always confirmed before booking. Drop-off always has no travel charge."},
              {color:"#9CA3AF",q:"Not sure of your distance?",a:"Enter your zip in the booking form and it estimates your distance automatically."},
            ].map(({color,q,a})=>(
              <div key={q} style={{background:"#fff",border:"1.5px solid #E5E7EB",borderRadius:10,padding:"14px 16px"}}>
                <div style={{display:"flex",alignItems:"flex-start",gap:8,marginBottom:6}}>
                  <div style={{width:9,height:9,borderRadius:"50%",background:color,flexShrink:0,marginTop:4}}/>
                  <p style={{fontSize:13,fontWeight:700,color:TEXT}}>{q}</p>
                </div>
                <p style={{fontSize:12,color:MUTED,lineHeight:1.6,paddingLeft:17}}>{a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{padding:"56px 48px",background:NAVY}}>
        <div style={{maxWidth:540,margin:"0 auto",textAlign:"center"}}>
          <h2 style={{fontSize:"clamp(20px,3vw,34px)",fontWeight:800,color:"#fff",marginBottom:10,letterSpacing:"-0.02em"}}>Ready to book?</h2>
          <p style={{fontSize:14,color:"rgba(255,255,255,0.5)",marginBottom:24,lineHeight:1.7}}>Head back to the main page to fill out the booking form. Takes about 2 minutes.</p>
          <a href="/#book" style={{background:"#fff",color:NAVY,padding:"13px 32px",borderRadius:6,fontWeight:700,fontSize:14,textDecoration:"none",display:"inline-block"}}>Start Booking</a>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={{background:"#080E20",padding:"36px",textAlign:"center"}}>
        <p style={{fontSize:15,fontWeight:800,color:"#fff",marginBottom:5}}>Kodiak <span style={{color:"rgba(255,255,255,0.38)"}}>Detailing</span></p>
        <p style={{fontSize:12,color:"rgba(255,255,255,0.35)",marginBottom:2}}>Serving Brookville, Ohio and the Greater Dayton Area</p>
        <p style={{fontSize:12,color:"rgba(255,255,255,0.3)",marginBottom:14}}>kodiakdetailpro@gmail.com</p>
        <div style={{display:"flex",justifyContent:"center",gap:18,marginBottom:14}}>
          <a href="/" style={{fontSize:12,color:"rgba(255,255,255,0.4)",textDecoration:"none"}}>Home</a>
          <span style={{color:"rgba(255,255,255,0.2)"}}>·</span>
          <a href="/#services" style={{fontSize:12,color:"rgba(255,255,255,0.4)",textDecoration:"none"}}>Services</a>
          <span style={{color:"rgba(255,255,255,0.2)"}}>·</span>
          <a href="/#book" style={{fontSize:12,color:"rgba(255,255,255,0.4)",textDecoration:"none"}}>Book Now</a>
        </div>
        <p style={{fontSize:11,color:"rgba(255,255,255,0.18)"}}>2026 Kodiak Detailing. All rights reserved.</p>
      </footer>
    </div>
  );
}
